import { LoaderCircle, type LucideIcon } from 'lucide-react'
import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger'
export type ButtonSize = 'small' | 'medium' | 'large'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  icon?: LucideIcon
  iconEnd?: ReactNode
  loading?: boolean
}

export function Button({
  children,
  className,
  variant = 'secondary',
  size = 'medium',
  icon: Icon,
  iconEnd,
  loading = false,
  disabled,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      className={mergeClassNames('ds-button', `ds-button--${variant}`, `ds-button--${size}`, className)}
      type={type}
      disabled={disabled === true || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      <span className={mergeClassNames('ds-button__content', loading && 'ds-button__content--hidden')}>
        {Icon ? <Icon aria-hidden="true" /> : null}
        <span>{children}</span>
        {iconEnd}
      </span>
      {loading ? <LoaderCircle className="ds-button__spinner" aria-hidden="true" /> : null}
    </button>
  )
}
